import React, { Component } from "react";
import ReactLightbox from "react-image-lightbox";
import PropTypes from "prop-types";

import "react-image-lightbox/style.css";

export default class Lightbox extends Component {
  constructor(props) {
    super(props);
    this.state = { pictureIndex: 0, prevPictureIndex: 0 };
  }

  static getDerivedStateFromProps({ pictureIndex }, state) {
    if (pictureIndex !== state.prevPictureIndex) {
      return { pictureIndex, prevPictureIndex: pictureIndex };
    }

    return null;
  }

  render() {
    const { pictureIndex } = this.state;
    const { onClose, pictures, spaces } = this.props;
    const space = spaces.find((s) => s.id === pictures[pictureIndex].spaceId);

    return (
      <ReactLightbox
        enableZoom={false}
        imageTitle={space ? <div>{space.name}</div> : undefined}
        mainSrc={pictures[pictureIndex].url}
        nextSrc={pictureIndex !== pictures.length - 1 ? pictures[pictureIndex + 1].url : ""}
        onCloseRequest={onClose}
        onMoveNextRequest={() =>
          this.setState({
            pictureIndex: (pictureIndex + 1) % pictures.length,
          })
        }
        onMovePrevRequest={() =>
          this.setState({
            pictureIndex: (pictureIndex + (pictures.length - 1)) % pictures.length,
          })
        }
        prevSrc={pictureIndex !== 0 ? pictures[pictureIndex - 1].url : ""}
      />
    );
  }
}

Lightbox.propTypes = {
  pictureIndex: PropTypes.number, // eslint-disable-line
  onClose: PropTypes.func,
  spaces: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number,
      name: PropTypes.string,
    })
  ),
  pictures: PropTypes.arrayOf(
    PropTypes.shape({
      url: PropTypes.string.isRequired,
    }).isRequired
  ),
};

Lightbox.defaultProps = {
  pictureIndex: 0,
  spaces: [],
};
